import React, { useEffect, useState, Fragment } from 'react'
import { handleError, slugToTitleCase } from 'config/libraries';
import { useParams } from "react-router-dom";
import { Main } from 'components/frame/main';

import Slider from "react-slick";

export const Detail = () => {
    
    let { slug } = useParams();
    const [DataResponse, setDataResponse] = useState(null);
    const [FadeClassName, setFadeClassName] = useState('fade-costum hide');
    
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
      };

    useEffect(() => {

        setFadeClassName('fade-costum')
        const axios = require('axios');
        axios.get(process.env.REACT_APP_SERVER_BASE_URL + '/detail-unit-layanan-aduan?slug_keluhan=' + slug).then(function (response) {
            setDataResponse(response.data.data[0]);
            setTimeout(() => {
                setFadeClassName('fade-costum')
            }, 300);
        }).catch(function (error) {
            handleError(error)
        })
        // return () => {
        //     setDataResponse(null);
        //     setFadeClassName('fade-costum hide');
        // };
    }, []);

    return (
        <Fragment>
            <Main>
            <section id="content_main" className={'clearfix jl_spost ' + FadeClassName}>
                <div className="container">
                    <div className="row main_content">
                        <div className="col-md-12 col-lg-12 col-xl-12 loop-large-post" id="content">
                            <div className="widget_container content_page">
                                <div className="post-2970 post type-post status-publish format-gallery has-post-thumbnail hentry category-business tag-inspiration tag-morning tag-tip tag-tutorial post_format-post-format-gallery" id="post-2970">
                                    <div className="single_section_content box blog_large_post_style"></div>
                                        {
                                            (DataResponse != null) ?
                                            <Fragment>
                                                <div className="jl_single_style2 mb-5 ">
                                                    <div className="single_post_entry_content single_bellow_left_align jl_top_single_title jl_top_title_feature">
                                                    <span className="meta-category-small single_meta_category">
                                                                <a className="post-category-color-text" style={{background: '#eba845'}} href="#">{DataResponse.kategori_ula}</a>
                                                            </span>
                                                            <h1 className="single_post_title_main">{DataResponse.judul_keluhan}</h1>
                                                            
                                                            <span className="jl_post_meta mb-3">
                                                                <span className="jl_author_img_w"><i className="jli-user" />
                                                                    <span href="#" title={DataResponse.nama_lengkap} rel="author">{DataResponse.nama_lengkap}</span>
                                                                </span>
                                                                <span className="jl_author_img_w"><i className="jli-user" />
                                                                    <span href="#" title={DataResponse.nomor_telepon} rel="author">{DataResponse.nomor_telepon}</span>
                                                                </span>
                                                                <span className="jl_author_img_w"><i className="jli-user" />
                                                                    <span href="#" title={DataResponse.email_aktif} rel="author">{DataResponse.email_aktif}</span>
                                                                </span>
                                                            </span>
                                                    </div>
                                                    <div className="jl_slide_wrap_s jl_clear_at">
                                                        <div className="jl_ar_top jl_clear_at">
                                                            <div className="jl-w-slider jl_full_feature_w">
                                                                <div className="jl-eb-slider jelly_loading_pro slick-initialized text-center">
                                                                <Slider {...settings}>
                                                                    {
                                                                        DataResponse.gambar_ula && DataResponse.gambar_ula.map((item, index) => {
                                                                            return (
                                                                                <div className='centered-slick-s' style={{ textAlign: 'center' }}>
                                                                                    <img className="image-detail-size-slick" src={process.env.REACT_APP_SERVER_IMAGE_URL + item.gambar_ula} alt={DataResponse.judul_keluhan}></img>
                                                                                    <div className="background_over_image" />
                                                                                </div>
                                                                            )
                                                                        })
                                                                    }
                                                                    </Slider>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="post_content_w mb-4">
                                                        <div>
                                                            <div className="post_subtitle_text" dangerouslySetInnerHTML={{ __html: DataResponse.isi_keluhan }}></div>
                                                        </div>
                                                        
                                                    </div>
                                                    <div className="container-lokasi">
                                                    <div className='width-100' dangerouslySetInnerHTML={{ __html: DataResponse.lokasi }}></div>
                                                    </div>
                                                </div>
                                                <div className="clearfix" ></div>
                                            </Fragment> : ''
                                        }
                                </div>
                                {/* <div className="brack_space" /> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            </Main>
        </Fragment>
    )
};